export default __webpack_public_path__ + "static/media/zalo_icon.d90ba1e4.svg";